"use strict";
import React from "react";
import { Shape } from "react-art";
import utils from "../../util/drawing_utils";
const { drawCircle, drawCenteredCircle } = utils;
const Circle = ({
  position,
  fillColor = "rgba(0,0,0,0)",
  lineColor = "rgba(0,0,0,0)",
  lineWidth = 0
}) => {
  const path = position.points ? (
    // @ts-ignore
    drawCircle(...position.points)
  ) : drawCenteredCircle(position.center, position.radius);
  return /* @__PURE__ */ React.createElement(
    Shape,
    {
      strokeWidth: lineWidth,
      stroke: lineWidth > 0 ? lineColor : null,
      fill: fillColor,
      d: path
    }
  );
};
export default Circle;
